/**
 * Primer nombre (o primer segmento si solo hay email) con primera letra en mayúscula
 * y el resto en minúsculas (locale es-ES). Para etiquetas y selectores de trabajadores.
 *
 * @param {string | null | undefined} value Nombre completo, email u otro fallback
 * @returns {string}
 */
export function formatWorkerDisplayName(value) {
  const raw = String(value ?? "").trim()
  if (!raw) return ""

  // Solo email / identificador sin espacios: usar parte local antes de @ o delimitadores
  if (raw.includes("@") && !/\s/.test(raw)) {
    const local = raw.split("@")[0] || raw
    const token = (local.split(/[.+_-]/)[0] || local).trim()
    if (!token) return raw.split("@")[0] || ""
    return titleCaseWord(token)
  }

  // Probable id largo sin espacios
  if (!raw.includes(" ") && raw.length > 24) {
    return raw.length > 12 ? `${raw.slice(0, 10)}…` : raw
  }

  const first = raw.split(/\s+/)[0]
  if (!first) return ""
  return first.replace(/[^\s'-]+/g, (w) => titleCaseWord(w))
}

function titleCaseWord(w) {
  if (!w) return ""
  return w.charAt(0).toLocaleUpperCase("es-ES") + w.slice(1).toLocaleLowerCase("es-ES")
}

export default formatWorkerDisplayName
